import React from "react";
import "./App.scss";
import Main from "./containers/Main";

function App() {
  return (
    <div style={{width:"100%"}}>
      <Main />
    </div>
  );
}

export default App;
